import { render, staticRenderFns } from "./ProgramServicePane.vue?vue&type=template&id=d83f1db0&scoped=true&"
import script from "./ProgramServicePane.vue?vue&type=script&lang=js&"
export * from "./ProgramServicePane.vue?vue&type=script&lang=js&"
import style0 from "./ProgramServicePane.vue?vue&type=style&index=0&id=d83f1db0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d83f1db0",
  null
  
)

export default component.exports